/* jshint esversion: 8 */
define([
  "computeResource/collections/collection"
], function (
  Collection
) {

  class LicenseManagerCollection extends Collection {

    constructor (args) {
      super(args);
    }

  }

  return LicenseManagerCollection;
});
